import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';

export const MobileCTABar = ({ navigate }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 220;
      setShow(window.scrollY > 700 && !nearBottom);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#060f1c]/95 px-4 py-3 backdrop-blur-xl transition-transform duration-300 lg:hidden ${show ? 'translate-y-0' : 'translate-y-full'}`}
      data-testid="landing-mobile-cta-bar"
    >
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <div className="truncate text-xs font-bold text-white">جرّب تسيار 30 يوماً مجاناً</div>
          <div className="truncate text-[10px] text-slate-400">دون بطاقة ائتمانية · إلغاء في أي وقت</div>
        </div>
        <button
          onClick={() => navigate('/register')}
          className="flex flex-shrink-0 items-center gap-1.5 rounded-full bg-gradient-to-l from-orange-500 to-orange-400 px-5 py-2.5 text-xs font-bold text-white shadow-[0_0_20px_rgba(245,76,7,0.35)]"
          data-testid="landing-mobile-cta-button"
        >
          ابدأ مجاناً <ArrowLeft className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default MobileCTABar;
